import React from "react";
import "./MenuTop.css";
import "./MenuPageUser.css";
import { Link, useLocation } from "react-router-dom";
import LoadingSquare from "shared/components/loading/LoadingSquare.js";
import * as fcl from "@onflow/fcl";

interface MenuPageUserProps {
  user: object;
  assistantUser: object;
}

const MenuPageUser: React.FC<MenuPageUserProps> = (props) => {
  const location = useLocation();

  const logOut = () => {
    fcl.unauthenticate();
    props.logout();
  };

  return (
    <div>
      <nav id="MenuPageUser" className="MenuTop navbar justify-content-center justify-content-md-start w-100 p-2">
        <div id="MenuPageUser" className="navbar d-md-none w-100 p-2 pb-0 justify-content-center">
          <Link className={"nav-link nav-user border px-2 d-flex flex-row"}>
            <i className="bi bi-person-circle me-1"></i>
            <span className="d-none d-md-inline ms-1">{props.user?.name ? props.user.name : <LoadingSquare />}</span>
          </Link>
        </div>
        <ul className="navbar-nav flex-row h6 ps-md-3">
          <li className="nav-item align-self-end lh-1 px-2 d-md-block d-none">
            <Link className={"nav-link nav-user border px-3 d-flex flex-row"}>
              <i className="bi bi-person-circle me-1"></i>
              <span className="d-none d-md-inline ms-1">{props.user?.name ? props.user.name : <LoadingSquare />}</span>
            </Link>
          </li>
          <li className="nav-item align-self-end lh-1 px-2">
            <Link
              to="overview"
              className={
                "nav-link" +
                (location.pathname.startsWith("/user/") &&
                !location.pathname.includes("/players") &&
                !location.pathname.includes("/clubs") &&
                !location.pathname.includes("/performance") &&
                !location.pathname.includes("/map")
                  ? " active"
                  : "")
              }
            >
              <i className="bi bi-columns mx-1"></i>
              <span className="d-none d-md-inline ms-1">Overview</span>
            </Link>
          </li>
          <li className="nav-item align-self-end lh-1 px-2">
            <Link
              to="players"
              className={
                "nav-link" +
                (location.pathname.startsWith("/user/") && location.pathname.includes("/players") ? " active" : "")
              }
            >
              <i className="bi bi-person-badge-fill mx-1"></i>
              <span className="d-none d-md-inline ms-1">Players</span>
            </Link>
          </li>
          <li className="nav-item align-self-end lh-1 px-2">
            <Link
              to="clubs"
              className={
                "nav-link" +
                (location.pathname.startsWith("/user/") && location.pathname.includes("/clubs") ? " active" : "")
              }
            >
              <i className="bi bi-buildings-fill mx-1"></i>
              <span className="d-none d-md-inline ms-1">Clubs</span>
            </Link>
          </li>
          <li className="nav-item align-self-end lh-1 px-2">
            <Link
              to="performance"
              className={
                "nav-link" +
                (location.pathname.startsWith("/user/") && location.pathname.includes("/performance") ? " active" : "")
              }
            >
              <i className="bi bi-bar-chart-line-fill mx-1"></i>
              <span className="d-none d-md-inline ms-1">Performance</span>
            </Link>
          </li>
          <li className="nav-item align-self-end lh-1 px-2">
            <Link
              to="map"
              className={
                "nav-link" +
                (location.pathname.startsWith("/user/") && location.pathname.includes("/map") ? " active" : "")
              }
            >
              <i className="bi bi-globe-americas mx-1"></i>
              <span className="d-none d-md-inline ms-1">Map</span>
            </Link>
          </li>
          {props.user?.address && props.assistantUser?.address === props.user?.address && (
            <li className="nav-item align-self-end lh-1 px-2">
              <Link onClick={logOut} className={"nav-link"}>
                <i className="bi bi-box-arrow-right text-danger mx-1"></i>
                <span className="d-none d-md-inline text-danger ms-1">Log out</span>
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default MenuPageUser;
